import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getPatientInteropUrls } from '../../../data/patients'
import { UserFriendlyError } from '../../../model/Error'
import { patientsKeys } from './patients.keys'

interface UseGetPatientInteropUrlsParams {
  patientId: number
  enabled?: boolean
}

export const useGetPatientInteropUrls = ({
  patientId,
  enabled = true,
}: UseGetPatientInteropUrlsParams) => {
  const queryKey = useMemo(() => patientsKeys.interopUrls(patientId), [patientId])

  const queryReturn = useQuery({
    queryKey,
    queryFn: async () => {
      const { data, ok } = await getPatientInteropUrls(patientId)
      if (!data || !ok) {
        throw new UserFriendlyError(
          'error',
          `Impossible de recuperer les URLs interop du patient`,
          `Une erreur technique s'est produite`,
        )
      }
      return data
    },
    enabled,
  })

  return { query: queryReturn }
}
